export default {
      id: "weather__night-thunder-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__night-thunder",
      toString: function () {
        return this.url;
      }
    }